import React from 'react';

import styles from './ActionsContainer.module.css';

const ActionsContainer = props => {
  return <div className={styles.root}>{props.children}</div>;
};

export default ActionsContainer;